export const ErrorMessages: Record<string, string> = {
  STUDENT_ALREADY_EXISTS: 'Student already exists',
  STUDENT_REGISTRATION_FAILED:
    'Student Registration failed Student already exists',
};
